import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import Seo from "@/components/Seo";
import { Toaster } from "@/components/ui/sonner";
import { content } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { TeaserSection } from "@/components/TeaserSection";
import { EditorialTicker } from "@/components/EditorialTicker";
import { StatsStrip } from "@/components/StatsStrip";
import { FictionSection } from "@/components/FictionSection";
import { FacilitatorSection } from "@/components/FacilitatorSection";
import { ExecProductionSection } from "@/components/ExecProductionSection";
import { LinksBar } from "@/components/LinksBar";
import { ContactSection } from "@/components/ContactSection";

function App() {
  const [lang, setLang] = useState("fr");
  const [dark, setDark] = useState(false);
  const t = content[lang];

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
  }, [dark]);

  return (
    <div className="App bg-paper text-ink min-h-screen">
      <Seo
        title="Thomas Lubeau — Production évènementielle & Producteur de fiction"
        siteName="Thomas Lubeau"
        description="Thomas Lubeau : production évènementielle (JO Paris 2024, Roland-Garros, +20 tournées de marques), producteur de fiction et producteur exécutif pour les tournages étrangers en France. Trouver des solutions à tout, optimiser chaque euro."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Person",
          name: "Thomas Lubeau",
          jobTitle: "Organisation évènementielle, producteur de fiction, producteur exécutif",
          knowsAbout: [
            "Production de fiction",
            "Événementiel",
            "Création et supervision d'événements",
            "Production exécutive — tournages étrangers en France",
            "Gestion de crise",
            "Logistique événementielle",
            "Direction de casting",
          ],
          url: "https://lubeau.com",
          sameAs: [
            "https://linktr.ee/thomaslubeau",
            "https://instagram.com/thomaslubeau",
            "https://www.linkedin.com/in/thomas-lubeau-2b1b64a5",
            "https://www.facebook.com/thomas.lubeau",
          ],
        }}
      />
      <Navbar t={t} lang={lang} setLang={setLang} dark={dark} setDark={setDark} />
      <main>
        <HeroSection t={t} lang={lang} />
        <TeaserSection t={t} />
        <EditorialTicker text={t.ticker} />
        <StatsStrip t={t} />
        <FacilitatorSection t={t} />
        <EditorialTicker text={t.ticker} reverse testid="editorial-marquee-ticker-2" />
        <FictionSection t={t} />
        <ExecProductionSection t={t} />
        <LinksBar t={t} />
        <ContactSection t={t} />
      </main>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
